export enum RtnCode {
  /** 成功 */
  CODE_SUCCESS = 0,
  /** 欄位驗證錯誤 */
  CODE_FIELD_CHECK_FAILURE = 1,
  /** 該使用者沒有權限 */
  NO_PERMISSION = 2,
  /** 查無任何紀錄 */
  CODE_DATA_NULL = 3,
  /** 使用者不存在 */
  NO_USER = 4,
  /** 系統參數不存在 */
  PARAM_ERROR = 5,
  /** 公司合約已終止 */
  CORP_ERROR = 6,
  /** 驗證碼錯誤，請重新輸入 */
  VERIFICATION_CODE_ERROR = 7,
  /** 檔案無法上傳，因為伺服器未啟用 */
  FILE_CAN_NOT_UPLOAD = 8,
  /** 檔案伺服器的儲存空間不足 */
  STORAGE_NOT_ENOUGH = 9,
  /** 提醒您，您目前輸入錯誤次數為{errorCount}次。 */
  LATCHKEY_ERROR = 10,
  /** 會員點數不足 */
  POINT_NOT_ENOUGH = 11,
  /** 兌換商品數量剩餘不足 */
  QTY_NOT_ENOUGH = 12,
  /** 身分升級失敗 */
  UPGRADE_FAILED = 13,
  /** 此功能群組名稱已重複 */
  DUPLICATED_FUNCTIONAL_GROUP_NAME = 14,
  /** 尚未綁定BizFam會員 */
  NOT_YET_BOUND = 15,
  /** 此成員群組名稱已重複 */
  DUPLICATED_MEMBER_GROUP_NAME = 16,
  /** 邀請信最多只能設置100組E-mail */
  MAIL_COUNT_LIMIT = 17,
  /** 優惠碼數量與數量額度不符 */
  COMMODITY_PROMO_CODE_QUANTITY = 18,
  /** 場站、營業人員、名稱至少需填一項 */
  CORPORATE_COURTESY_SEARCH = 19,
  /** 出發地、目的地需填寫 */
  TRAVEL_ROUTES_REQUIRED = 20,
  /** 航空公司代碼需填寫 */
  AIRLINE_PROPORTION_REQUIRED = 21,
  /** 系統異常，請聯繫長榮航空。(E9999) */
  FFP_ERROR_E9999 = 22,
  /** 系統異常，請聯繫長榮航空。(E0999) */
  FFP_ERROR_E0999 = 23,
  /** 系統維護中，請聯繫長榮航空。(E0000) */
  FFP_ERROR_E0000 = 24,
  /** 成功 */
  FFP_ERROR_E0001 = 25,
  /** 必填欄位空白。(E0002) */
  FFP_ERROR_E0002 = 26,
  /** 輸入格式不正確。(E0003) */
  FFP_ERROR_E0003 = 27,
  /** 企業會員帳號已存在。(E0004) */
  FFP_ERROR_E0004 = 28,
  /** 點數已存在。(E0005) */
  FFP_ERROR_E0005 = 29,
  /** 企業會員帳號不存在。(E0006) */
  FFP_ERROR_E0006 = 30,
  /** 合約資料不正確。(E0007) */
  FFP_ERROR_E0007 = 31,
  /** 無此卡號。(E0008) */
  FFP_ERROR_E0008 = 32,
  /** 企業會員帳號已存在。(E0009) */
  FFP_ERROR_E0009 = 33,
  /** 會員卡號未綁定。(E0010) */
  FFP_ERROR_E0010 = 34,
  /** 會員卡號解除綁定失敗。(E0011) */
  FFP_ERROR_E0011 = 35,
  /** 來自FFP錯誤：E0105 */
  FFP_ERROR_E0105 = 36,
  /** 航線重複 */
  TRAVEL_ROUTES_REPEAT = 38,
  /** 此券號已被鎖定，需由原人員核銷或解鎖 */
  COURTESY_WRITE_OFF_LOCK = 39,
  /** 客戶聯絡人已達上限20組 */
  CONTRACT_PERSON_MAX = 40,
  /** 指定日期必填 */
  VISIT_REMIND_SPECIFY_DATE = 41,
  /** 重複日期/重複間隔/每月必填 */
  VISIT_REMIND_DATE = 42,
  /** 主帳號已存在 */
  CORPORATE_ACCOUNT_EXIST = 43,
  /** 子帳號數量已達上限 */
  CORPORATE_ACCOUNT_SUB_LIMIT = 44,
  /** 主子帳號Email不可重複 */
  CORPORATE_ACCOUNT_EMAIL_EXIST = 45,
  /** 您已嘗試登入，帳戶資訊錯誤已連續達到5次，帳號已鎖。如有任何問題請洽長榮航空業務人員，謝謝。 */
  LOGIN_TRY_LATCHKEY_OVER_TIMES = 46,
  /** 第一次登入須重設密碼 */
  FIRST_LOGIN_NEED_RESET_LATCHKEY = 47,
  /** 超過90天未變更密碼，須重設密碼 */
  OVER_DAYS_LOGIN_NEED_RESET_LATCHKEY = 48,
  /** 新密碼與確認密碼不相同 */
  NEW_LATCHKEY_CANT_MATCH = 49,
  /** 密碼須符合:8-16碼、至少一個數字及大小寫英文字母 */
  NEW_LATCHKEY_RULE_FAIL = 50,
  /** 新密碼不得與原密碼相同 */
  NEW_LATCHKEY_CANT_MATCH_OLD_LATCHKEY = 51,
  /** 驗證碼錯誤或已過期 */
  CAPTCHA_CODE_ERROR = 52,
  /** 企業帳號已被刪除，請檢查輸入資訊。 */
  LOGIN_ACCOUNT_IS_DELETED = 53,
  /** 此企業帳號已停權。如有任何問題請洽長榮航空業務人員,謝謝。 */
  CORPORATE_ACCOUNT_NO_PERMISSION = 54,
  /** 企業帳號與企業帳號 E-mail 比對不符合,請重新輸入 */
  CORPORATE_ACCOUNT_EMAIL_ERROR = 55,
  /** 驗證碼過期，請重新輸入 */
  VERIFICATION_CODE_EXPIRED = 56,
  /** 查無卡號資訊，請重新輸入 */
  MEMBERCARDNUMBER_NOT_FOUND = 60,
  /** 輸入的一次性動態密碼錯誤，請重新輸入 */
  OTP_IS_INCORRECT = 66,
  /** 輸入的一次性動態密碼已過期，請重新登入 */
  OTP_HAS_EXPIRED = 67,
  /** 此券號正在安排中，請按確認鍵重新整理 */
  COURTESY_IS_BEING_ARRANGED = 68,
  /** 上傳名單不符合格式規定 */
  DISTRIBUTION_LIST_FORMAT_ERROR = 73,
  /** 來自FFP:系統錯誤. */
  FFP_ERROR_FRONT = 90,
  /** 來自FFP:里程兌換系統錯誤. */
  EVA_ERROR_MILEAGE_EXCHANGE = 91,
  /** 檔案已加密，無法上傳 */
  FILE_ENCRYPTED = 92,
  /** 伺服器錯誤 */
  CLIENT_SERVER_ERROR = 93,
  /** AD帳號已被鎖定，請洽管理員 */
  AD_LOCK = 94,
  /** token找不到 */
  NO_TOKEN = 95,
  /** token過期 */
  TOKEN_EXPIRED = 96,
  /** 帳號或密碼不正確，請檢查輸入的帳密 */
  ACCOUNT_LATCHKEY_FAILURE = 97,
  /** 資料庫錯誤 */
  DATABASE_FAILURE = 98,
  /** 系統維護中，請稍後再試 */
  CODE_FAILURE = 99,
  /** 系統查無您的權限。如需系統權限，請逕自向RMC同仁確認並於AAMS上申請BizFam權限，謝謝。 */
  BIZFAM_LOGIN_FAILURE = 100,
  /** 網頁出現錯誤，請通知長榮航空業務人員，感謝您的協助。 */
  IP_Block = 101,
  /** ISSUE區間必填 */
  CONTRACT_ISSUE_DATE_REQUIRED = 200,
  /** 新合約的生效期間不得與同企業任何活動合約重疊。若設置自動續約，則同企業所有活動合約中僅允許該合約開啟此功能。狀態包括：審核中、駁回、等待生效、取消生效中、已生效、不續約及異動審核中的合約。 */
  CONTRACT_ISSUE_DATE_OVERLAP = 201,
  /** Eva Point、Fare Discount、企業購票方案需至少選一種 */
  CONTRACT_PROGRAM_REQUIRED = 202,
  /** 方案不存在 */
  CONTRACT_PROGRAM_NONEXISTENT = 203,
  /** Fare Discount格式錯誤 */
  CONTRACT_FARE_DISCOUNT_INCORRECT = 204,
  /** 企業官網購票方案格式錯誤 */
  CONTRACT_PURCHASE_PROGRAM_INCORRECT = 205,
  /** 自動續約(年)必填 */
  CONTRACT_AUTO_RENEW_YEAR_REQUIRED = 206,
  /** 企業已有自動續約合約 */
  CONTRACT_AUTO_RENEW_EXIST = 207,
  /** 生效日期、出發日期、最後搭乘日期必填 */
  CONTRACT_STOP_DATE_REQUIRED = 208,
  /** 企業尚有剩餘點數 */
  CONTRACT_POINTS_REMAIN = 209,
  /** 仍有尚未指派、尚未使用的客戶禮遇 */
  CONTRACT_UNBIND_COURTESY = 210,
  /** 不可早於前份失效合約的起始日 */
  CONTRACT_ISSUE_DATE_INVALID = 211,
  /** 企業帳號識別碼已關閉，請洽詢長榮業務人員。 */
  IDENTIFY_ID_INCORRECT = 212,
  /** 企業識別碼不存在 */
  IDENTIFY_ID_DOES_NOT_EXIST = 213,
  /** 系統異常，請聯繫長榮航空。(A0001) */
  EVA_1A_A0001 = 401,
  /** 系統異常，請聯繫長榮航空。(A0002) */
  EVA_1A_A0002 = 402,
  /** 系統異常，請聯繫長榮航空。(A0003) */
  EVA_1A_A0003 = 403,
  /** 系統異常，請聯繫長榮航空。(A0004) */
  EVA_1A_A0004 = 404,
  /** 系統異常，請聯繫長榮航空。(A0005) */
  EVA_1A_A0005 = 405,
  /** 系統異常，請聯繫長榮航空。(A0006) */
  EVA_1A_A0006 = 406,
  /** 系統異常，請聯繫長榮航空。(A0007) */
  EVA_1A_A0007 = 407,
  /** 系統異常，請聯繫長榮航空。(A0008) */
  EVA_1A_A0008 = 408,
  /** 系統異常，請聯繫長榮航空。(A0009) */
  EVA_1A_A0009 = 409,
  /** 系統異常，請聯繫長榮航空。(A0010) */
  EVA_1A_A0010 = 410,
  /** 系統異常，請聯繫長榮航空。(A0011) */
  EVA_1A_A0011 = 411,
  /** 系統異常，請聯繫長榮航空。(A0012) */
  EVA_1A_A0012 = 412,
  /** 無效的會員卡號。(A0013) */
  EVA_1A_A0013 = 413,
  /** 系統忙碌中，請稍候再試。(A0014) */
  EVA_1A_A0014 = 414,
  /** 查無機票號碼，無法安排禮遇。(A0015) */
  EVA_1A_A0015 = 415,
  /** 超額行李限訂購五件，請重新確認訂購資訊。(A0016) */
  EVA_1A_A0016 = 416,
  /** 此行程不適用機場禮遇相關之服務。(A0017) */
  EVA_1A_A0017 = 417,
  /** 班機已落入不可安排機場禮遇之服務時間，故無法使用，謝謝。(A0018) */
  EVA_1A_A0018 = 418,
  /** 航班已完成報到，無法使用機場禮遇相關服務。(A0019) */
  EVA_1A_A0019 = 419,
  /** 來自哩程兌換:System Error. */
  EVA_MILEAGE_EXCHANGE = 444,
  /** 來自哩程兌換:請聯繫長榮航空。(00) */
  EVA_MILEAGE_EXCHANGE_00 = 445,
  /** 來自哩程兌換:無此卡號。(01) */
  EVA_MILEAGE_EXCHANGE_01 = 446,
  /** 來自哩程兌換:姓名錯誤。(02) */
  EVA_MILEAGE_EXCHANGE_02 = 447,
  /** 來自哩程兌換:系統異常，請聯繫長榮航空。(03) */
  EVA_MILEAGE_EXCHANGE_03 = 448,
  /** 來自哩程兌換:系統異常，請聯繫長榮航空。(04) */
  EVA_MILEAGE_EXCHANGE_04 = 449,
  /** 來自哩程兌換:帳號錯誤。(05) */
  EVA_MILEAGE_EXCHANGE_05 = 450,
  /** 來自哩程兌換:出生年月日錯誤。(06) */
  EVA_MILEAGE_EXCHANGE_06 = 451,
  /** 來自哩程兌換:資料重複。(07) */
  EVA_MILEAGE_EXCHANGE_07 = 452,
  /** 來自哩程兌換:企業會員帳號錯誤。(12) */
  EVA_MILEAGE_EXCHANGE_12 = 453,
  /** 來自哩程兌換:企業會員以達到哩程兌換上限。(14) */
  EVA_MILEAGE_EXCHANGE_14 = 454,
  /** 您的密碼已修改，請重新登入 */
  LATCHKEY_CHANGED = 998,
  /** 您的帳號權限已調整，請重新登入 */
  ACCESS_PERMISSIONS_MODIFIED = 999
}
